// extracted by mini-css-extract-plugin
export var item = "dY_rM";
export var text = "dY_gJ";